// Auth service to handle token retrieval
let auth0Instance = null

export const setAuth0Instance = (instance) => {
  auth0Instance = instance
  console.log('Auth0 instance set in auth service:', instance)
}

export const getAccessToken = async () => {
  if (!auth0Instance) {
    throw new Error('Auth0 instance not set')
  }
  
  try {
    // For Auth0 Vue v2.4.0, getAccessTokenSilently is available on the instance
    const token = await auth0Instance.getAccessTokenSilently({
      detailedResponse: false
    })
    
    if (!token) {
      throw new Error('No token returned from Auth0')
    }
    
    return token
  } catch (error) {
    console.error('Error getting access token:', error)
    
    // If the error is about missing refresh token, redirect to login
    if (error.error === 'missing_refresh_token' || 
        error.message?.includes('Missing Refresh Token') ||
        error.message?.includes('missing_refresh_token')) {
      console.log('Refresh token missing, redirecting to login...')
      // Redirect to login to get a new refresh token
      await loginWithRedirect()
      // Don't throw here - the redirect will happen
      throw new Error('Redirecting to login to obtain refresh token')
    }
    
    throw error
  }
}

export const loginWithRedirect = async () => {
  if (!auth0Instance) {
    throw new Error('Auth0 instance not set')
  }
  return await auth0Instance.loginWithRedirect({
    authorizationParams: {
      redirect_uri: `${window.location.origin}/callback`,
      scope: 'openid profile email offline_access' // Include offline_access for refresh tokens
    }
  })
} 